import { useMemo, useState } from "react";

import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import { Button } from "V2.0/common/button";
import { PlusIcon } from "@heroicons/react/24/outline";

import { processTemplateForParameters } from "V2.0/HomePages/HomeCampaign/SingleContact/WhatsAppV2/utils";
import WhatsappTemplateAttributesAdd from "V2.0/HomePages/HomeCampaign/SingleContact/WhatsAppV2/Meta/WhatsappTemplateAttributesAdd";
import useMCubeEngageWhatsappTemplates from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/useMCubeEngageWhatsappTemplates";

export default MCubeEngageTemplateForm;

function MCubeEngageTemplateForm(props) {
  const { errors, formState, workspaceId, updateFormState } = props;

  const { templates } = useMCubeEngageWhatsappTemplates(workspaceId);

  const [addAttributes, setAddAttributes] = useState(false);

  const activeTemplate = useMemo(() => {
    const { templateName } = JSON.parse(formState.template);
    console.log({templateName, template: formState.template, templates})

    if (!templateName || templates.data.length === 0) return undefined;


    const messageTemplate = templates.data.find((_messageTemplate) => {
      return _messageTemplate.name === templateName;
    });

    return {
      ...messageTemplate,
      components: JSON.parse(messageTemplate.components),
    };
  }, [formState.template, templates.data]);

  const parameters = useMemo(() => {
    if (!activeTemplate) return [];

    return processTemplateForParameters(activeTemplate);
  }, [activeTemplate]);

  const templateOptions = templates.data.reduce(
    (acc, messageTemplate, index) => {
      acc.push({
        id: index+1,
        value: JSON.stringify({
          templateName: messageTemplate.name,
          templateLanguage: messageTemplate.language,
        }),
        label: messageTemplate.name,
      });
      return acc;
    },
    [
      {
        id: 0,
        value: JSON.stringify({
          templateName: "",
          templateLanguage: "",
        }),
        label: "(No template selected)",
      },
    ],
  );

  const renderAddAttributes = (
    <Button
      plain
      onClick={() => setAddAttributes(true)}
    >
      <PlusIcon /> Attributes
    </Button>
  );

  const renderViewMessage = (
    <Button
      plain
      onClick={() => setAddAttributes(true)}
    >
      View Message
    </Button>
  );

  const renderInfo = Boolean(parameters.length)
    ? renderAddAttributes
    : renderViewMessage;

  return (
    <>
      <Field>
        <Label>Template *</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.template}
          defaultValue={formState.template}
          invalid={!!errors.template}
          onChange={(value) => updateFormState("template", value)}
        >
          {templateOptions.map((templateOption) => {
            return (
              <ListboxOption key={templateOption.id} value={templateOption.value}>
                <ListboxLabel>{templateOption.label}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
        {errors.template && <ErrorMessage>{errors.template}</ErrorMessage>}
        {Boolean(activeTemplate) && renderInfo}
      </Field>
      {addAttributes && (
        <WhatsappTemplateAttributesAdd
          template={activeTemplate}
          onClose={() => setAddAttributes(false)}
          parametersInitialValues={formState.attributes}
          onUpdateParameters={(data) => updateFormState("attributes", data)}
        />
      )}
    </>
  );
}
